export enum SettingsPageUrlFragmentEnum {
  GENERAL = 'general',
  SUBSCRIPTION = 'subscription',
  ONBOARDING = 'onboarding',
}
